/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, getter-return */
// Ember imports
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { htmlSafe } from '@ember/template';
// External imports
import md5 from 'blueimp-md5';
// Internal imports
import PostType from '@linc-technologies/linced-common/enums/post-type';
import NotificationType from '@linc-technologies/linced-common/enums/notification-type';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class HeroNotification extends Component {
  // Component versioning
  @tracked visualStyle = 'v1';

  htmlSafe = htmlSafe;
  PostType = PostType;

  @service
  notifications;

  post = null;
  entityId = null;
  resultId = null;
  isPostType = false;

  // onRead will be called if/when this notification is marked as read.
  onRead() {}

  isRead = false;

  @alias('notifications.markReadInProgress')
  markReadInProgress;

  @tracked defaultAvatar =
    `https://gravatar.com/avatar/${md5('none')}?d=mp&f=y`;

  @computed('post.groups.content.[]')
  get groups() {
    if (!this.isPostType) {
      return;
    }
    let allGroups = resolved(this.post.groups);
    if (allGroups.length < 3) {
      return allGroups;
    }
    let extraGroups = allGroups.length - 2;
    let groups = allGroups.slice(0, 2);
    groups.push({
      name: `+ ${extraGroups} More`,
      email: '',
      image: this.defaultAvatar,
    });

    return groups;
  }

  @computed('notification.type')
  get isCalendarAndExcursions() {
    let calendarAndExcursionTypes = [
      NotificationType.EVENT_REQUIRES_APPROVAL,
      NotificationType.EVENT_CANCELLED,
      NotificationType.EVENT_DAILY_REMINDER,
      NotificationType.EVENT_CLOSURE_REMINDER,
      NotificationType.EVENT_OPEN_TO_CAREGIVERS,
      NotificationType.EVENT_PERMISSION_REMINDER,
      NotificationType.EVENT_APPROVED,
      NotificationType.EVENT_OPEN_TO_STAFF,
    ];

    return calendarAndExcursionTypes.includes(this.notification.type);
  }

  @computed('notification.type')
  get isReportPublished() {
    return this.notification.type === NotificationType.REPORT_PUBLISHED;
  }

  // avatar determines the various parameters of the avatar to show for this notification.
  @computed('post.{postType,school,person,author}', 'defaultAvatar')
  get avatar() {
    let person;

    if (!isEmpty(this.post)) {
      switch (this.post.postType) {
        case PostType.COMMUNITY_NOTICE:
          return {
            resource: this.get('post.school'),
            caption: this.get('post.school.name'),
          };
        case PostType.STUDENT_NOTICE:
          return {
            resource: this.get('post.author'),
            caption: this.get('post.author.fullName'),
          };

        default:
          if (!isEmpty(this.post.person)) {
            person = this.get('post.person');
          } else if (!isEmpty(this.post.author)) {
            person = this.get('post.author');
          }
          if (!isEmpty(person)) {
            return {
              resource: person,
              caption: person.get('fullName'),
            };
          }
      }
    }

    return {
      url: this.defaultAvatar,
      caption: 'Unknown',
    };
  }

  @action
  closeMenu() {
    this.menu.actions.close();
  }

  // Named dismissDialog rather than closeDialog: that name is a callback
  // passed into this component, so as a method here it would call itself.
  // closeDialog only closes the dialog/menu this notification is rendered
  // in - it doesn't perform a route transition - so the link's own href
  // (a real in-app URL from href-to/post.url) has to be left alone to
  // actually navigate; this only needs to close the dialog behind it.
  @action
  dismissDialog() {
    this.closeDialog();
  }

  @action
  markRead() {
    this.notifications.markEntityRead(this.entityId);
  }

  @action
  markResultRead() {
    this.notifications.markResultRead(this.resultId);
  }
}
